import styled from 'styled-components'

import env from 'env'

import { LocationContent } from './styled'

interface IListingStaticMap {
  position?: google.maps.LatLngLiteral
}

const StaticMapImg = styled.img`
  width: 100%;
`

const GOOGLE_STATIC_MAPS_API_URL = 'https://maps.googleapis.com/maps/api/staticmap'
const GOOGLE_STATIC_MAPS_API_SETTINGS = '&zoom=15&size=640x304&scale=2'

export const generateGoogleStaticMapUrl = (position?: google.maps.LatLngLiteral) =>
  `${GOOGLE_STATIC_MAPS_API_URL}?key=${env.GOOGLE_MAP_KEY}&markers=${position?.lat},${position?.lng}${GOOGLE_STATIC_MAPS_API_SETTINGS}`

export const ListingStaticMap: React.FC<IListingStaticMap> = ({ position }) => {
  if (!position) return null
  const googleMapStaticUrl = generateGoogleStaticMapUrl(position)
  return (
    <LocationContent>
      <StaticMapImg src={googleMapStaticUrl} alt="Google Static Map" />
    </LocationContent>
  )
}

ListingStaticMap.defaultProps = {
  position: undefined,
}
